<template>
    <tr>
        <td :colspan="colspan" class="empty-state">
            <div class="empty-content">
                <i class="bi bi-inbox"></i>
                <h3>{{ header }}</h3>
                <p>
                    {{ instruction }}
                </p>
            </div>
        </td>
    </tr>
</template>

<script setup>
//eslint-disable-next-line
const props = defineProps({
    colspan: {type: Number, default: 6},
    instruction: {type: String, default: "Try adjusting your search criteria or clear filters to see all records."},
    header: {type:  String, default: "No records found"}
});
</script>

<style scoped>

/* Empty State */
.empty-state {
  padding: 4rem 2rem;
  text-align: center;
}

.empty-content {
  color: #718096;
}

.empty-content i {
  font-size: 4rem;
  margin-bottom: 1rem;
  opacity: 0.5;
}

.empty-content h3 {
  margin: 0 0 0.5rem 0;
  color: #4a5568;
}

.empty-content p {
  margin: 0;
  font-size: 0.9rem;
}

</style>